<template>
		<form 
			method="post" 
			ref="themeForm"
			class="uk-form-stacked" 
			accept-charset="UTF-8" 
			autocomplete="off" 
			@submit.prevent="submitForm"
			>	
			<input type="hidden" :name="csrfName" :value="csrfToken">	
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="userId">
				<div>
					<label class="uk-switch theme-switcher" :for="formKey">
						<input type="checkbox" :id="formKey" @click="toggleSwitch" :value="darkThemeValue" ref="lightswitch">
						<div class="uk-switch-slider theme-switcher"></div>
					</label>
				</div>
				<div style="font-size: 0.5rem; margin-top: -3px">
					Nachtmodus
				</div>
		</form>
</template>

<script>
	
import Cookies from 'js-cookie';
import axios from 'axios';

export default {
	name: "theme-switcher",
	props: {
		userId: {
			type: Number,
			default: 0,
		},
		dark: {
			type: Boolean,
			default: false
		} 
	},
	data() {
		return {
			formKey: null,
			darkThemeValue: null,
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName;
		},
		csrfToken() {
			return window.csrfTokenValue;
		},
	},
	mounted() {
		
		var component = this;
		
		component.$logger("app/components/theme-switcher/mounted");
		
		component.formKey = "theme-switcher-" + component.$helper.getRandInteger();		
		component.darkThemeValue = (component.dark) ? 1 : 0;
		
		component.setLightswitch();
	},
	created() {
		this.$logger("app/components/theme-switcher/created");
	},
	methods: {
		setLightswitch() {
			
			var component = this;
			var lightswitch = component.$refs.lightswitch
			
			if (component.dark) {
				lightswitch.setAttribute("checked", "checked");
			} else {
				lightswitch.removeAttribute("checked");
			}			
		},
		toggleSwitch(e) {

			var component = this;

			component.$logger("app/components/theme-switcher/toggleSwitch");
			
			var form = component.$refs.themeForm;
			var element = e.target;
			
			// Update global
			if (element.checked) {
				component.darkThemeValue = '1';
			} else {
				component.darkThemeValue = '0';
			}

			// Update checkbox
			component.setLightswitch();

			// Set cookie
			Cookies.set('darkTheme', component.darkThemeValue, { expires: 365 });
			
			// Change css class
			if (document.body.classList.contains("dark")) {
				document.body.classList.remove("dark");
			} else {
				document.body.classList.add("dark");
			}
			
			// Update app instance
			//app.__vue_app__._instance.ctx.user.darkTheme = (element.checked) ? true : false;
						
			// Submit form, or show notification for anonymous users
			if (component.userId > 0) {
				component.submitForm(form);
			} else {
				setTimeout(function () {
					component.$helper.confirmModal({
						title:
							"<h4>Tip van de dag</h4>Maak een gratis account aan en je voorkeur voor deze instelling wordt op ieder device/browser onthouden.<br><br>Wil je nu een account aanmaken?",
						onConfirm: function () {
							window.location = "/aanmelden";
						},
						onCancel: function () {},
					});
				}, 1000);
			}
							
		},
		submitForm(form) {

			var component = this;

			component.$logger("app/components/theme-switcher/submitForm");
						
			// Form data
			var formData = new FormData(form);
			
			// Custom data
			var data = {};
			
			// Add darkTheme value
			formData.append("fields[darkTheme]", component.darkThemeValue);
			
			// Request
			axios({
				method: "post",
				url: "/",
				responseType: "json",
				data: formData,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					Accept: "application/json",
				},
			})
			.then(function (response) {
				if (response.data.error) {
					// Error
					component.$logger("app/components/dark-mode-switch/response/error");
				} else {
					// Success
					component.$logger("app/components/dark-mode-switch/response/success");
				}
			})
			.catch(function (result) {
				component.$logger("app/components/dark-mode-switch/catch", "error");
		
				// Json response
				var response = error.response.data;
				var errorCode = response.errorCode;
				var message = response.message;

			});
		},
	},
}
</script>

<!-- Add any styles if required -->
<style scoped>
.uk-switch.theme-switcher {
	height: 24px;
	width: 50px;
}
.uk-switch-slider.theme-switcher {
	background-color: rgb(61 60 68);
}
.uk-switch-slider:before {
	width: 22px;
	height: 22px;
}

</style>
